import { IModalProps, Modal } from 'native-base';
import React from 'react';
import { Platform } from 'react-native';

import BlurOverlay from 'app/components/BlurOverlay';
import { useI18n } from 'app/providers/I18nProvider';
import { tID } from 'app/services/TestHelper';

export type CPModalProps = IModalProps & {
  blurBackdrop?: boolean;
};

function CPModal({ blurBackdrop = false, children, ...props }: CPModalProps) {
  const { t } = useI18n();
  return (
    <Modal
      testID={tID('CPModal')}
      useRNModal={Platform.OS === 'ios'}
      {...props}
      backdropVisible={false}
    >
      <BlurOverlay
        accessibilityLabel={
          props.closeOnOverlayClick && props.onClose ? `${t<string>('gen_close')} Modal` : undefined
        }
        isBlurred={blurBackdrop}
        onPress={props.closeOnOverlayClick ? props.onClose : undefined}
      />
      {children}
    </Modal>
  );
}

CPModal.Body = Modal.Body;
CPModal.CloseButton = Modal.CloseButton;
CPModal.Content = Modal.Content;
CPModal.Footer = Modal.Footer;
CPModal.Header = Modal.Header;

export default CPModal;
